<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M15.12,6.63C15.12,6.63,14.74,6.63,14.74,6.63C14.74,6.63,15,7,15,7C14.99,7.3,14.99,7.64,15,7.98C15,7.99,15,7.99,15,8C15,8.07,14.97,8.13,14.96,8.19C14.96,8.19,14.98,8.19,14.98,8.19C14.98,8.19,14,13.1,14,13.1C14,13.1,14,14,14,14C14,14.55,13.55,15,13,15C12.45,15,12,14.55,12,14C12,14,12,13,12,13C12,13,4,13,4,13C4,13,4,14,4,14C4,14.55,3.55,15,3,15C2.45,15,2,14.55,2,14C2,14,2,13.1,2,13.1C2,13.1,1.02,8.2,1.02,8.2C1.02,8.2,1.04,8.2,1.04,8.2C1.03,8.13,1,8.07,1,8C1,8,0.99,8,0.99,8C0.99,7.67,0.99,7.33,1,7C1,7,1.26,6.63,1.26,6.63C1.26,6.63,0.88,6.63,0.88,6.63C0.4,6.63,0,6.21,0,5.69C0,5.17,0.4,4.75,0.88,4.75C0.88,4.75,1.93,4.75,1.93,4.75C1.93,4.75,2.7,2.64,2.7,2.64C2.89,2.11,3.46,1.56,3.96,1.4C3.96,1.4,4.64,1.2,6.01,1.08C6.01,1.05,6,1.03,6,1C6,0.45,6.45,0,7,0C7,0,9,0,9,0C9.55,0,10,0.45,10,1C10,1.03,9.99,1.05,9.98,1.08C11.35,1.2,12.03,1.4,12.03,1.4C12.54,1.55,13.11,2.11,13.3,2.64C13.3,2.64,14.06,4.76,14.06,4.76C14.06,4.76,15.11,4.76,15.11,4.76C15.6,4.76,16,5.18,16,5.69C16,6.21,15.6,6.63,15.12,6.63C15.12,6.63,15.12,6.63,15.12,6.63ZM11,10C11,10,13,10,13,10C13,10,13,8,13,8C13,8,13,8,13,8C13,8,11,8,11,8C11,8,11,10,11,10C11,10,11,10,11,10ZM3,10C3,10,5,10,5,10C5,10,5,8,5,8C5,8,3,8,3,8C3,8,3,8,3,8C3,8,3,10,3,10C3,10,3,10,3,10ZM13,5C13,5,12.27,3.37,12.27,3.37C12.21,3.19,12.18,3,12,3C12,3,4,3,4,3C3.82,3,3.79,3.19,3.73,3.37C3.73,3.37,3,5,3,5C2.94,5.18,2.82,6,3,6C3,6,13,6,13,6C13.18,6,13.06,5.18,13,5C13,5,13,5,13,5Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Taxi',
} as DefineComponent
</script>
